<script setup lang="ts">
import type { Comment } from '~/api/drupal'
const props = defineProps<{
  items: Comment[]
}>()
</script>
<template>
  <ul class="comments cul">
    <li v-for="item in items" :key="item.id" class="item">
      <Comment v-bind="item" />
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.item .item:last-child .comment {
  padding: 0;
  margin: 0;
  border-bottom-color: transparent;
}
</style>
